import { createFileRoute } from "@tanstack/react-router";
import HmacGeneratorPage from "@/pages/HmacGeneratorPage";

export const Route = createFileRoute("/tools/hmac-generator")({
  component: HmacGeneratorPage,
});
